import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Initialize i18next
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'fr', 'de'],
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },

    ns: ['common', 'auth'],
    defaultNS: 'common',

    // Don't block rendering while loading translations
    react: {
      useSuspense: false,
    },

    // Load other namespaces on demand
    partialBundledLanguages: true,
  });

export default i18n;

// Helper function to change language
export async function changeLanguage(lng: string): Promise<void> {
  localStorage.setItem('language', lng);
  await i18n.changeLanguage(lng);
}

// Helper function to get current language
export function getCurrentLanguage(): string {
  return i18n.language;
}

// Available languages
export const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
];
